<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      v-model="date"
      :label="label"
      :single-line="!showLabel"
      prepend-icon="event"
      readonly
      :clearable="clearable"
      :error-messages="errorMessages"
    ></v-text-field>

    <v-date-picker light v-model="date" locale="es-ar" :readonly="readonly" :type="month ? 'month' : 'date'"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: String,
    label: {
      type: String,
      default: 'Fecha'
    },
    errorMessages: {
      type: Array,
      default: () => { return [] }
    },
    clearable: Boolean,
    readonly: Boolean,
    month: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    date: {
      set (newValue) {
        this.inputDate(newValue)
      },
      get () {
        return this.value
      }
    }
  },

  data () {
    return {
      menu: false
    }
  },

  methods: {
    inputDate (value) {
      this.menu = false
      this.$emit('input', value)
    }
  },

  created () {
    if (this.value === '') {
      this.inputDate(new Date().toISOString().substr(0, 10))
    }
  }
}
</script>
